import React from "react";
import "../styles/about.css";

import me from "../assets/sanjeet.png";
import { Heading } from "../styled-components/Heading";

export const About = () => {
  return (
    <section id="about" className="about">
      <div className="heading" data-aos="fade-down">
        <Heading>
          <h2>About Me</h2>
        </Heading>
      </div>

      <div className="about__content">
        <div data-aos="fade-right" className="profile__image">
          <img src={me} alt="sanjeet" />
        </div>

        <div className="profile__info">
          <h4 data-aos="fade-down">
          Full stack developer with hands-on experience in developing and deploying web applications. <br /> 
          Proficient in multiple programming languages and frameworks, specializing in crafting intuitive and adaptable user interfaces. <br /> 
          Collaborative team player known for strong communication and teamwork abilities. <br /> 
          Seeking to leverage my skills in a challenging role at a dynamic company. <br /> <br />
            <br />
            <br />
          </h4>
        </div>
      </div>
    </section>
  );
};
